import {
    STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBrandsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                modelOptions: [],
                yearOptions: [],
                versionOptions: [],
                brandOptions: [],
                brandOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBrandsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                brandOptions: action.data,
                brandOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBrandsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                brandOptions: [],
                brandOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  